import { appVersion } from '../version';

export const environment = {
  production: false,
  serverUrls: {
    kontorserver: 'https://kontorcms.gitapp.de',
    kontorserverDev: 'http://localhost:3000',
    nocoDBUrl: 'https://noco.acrow.de',
    nocoProductTable: 'mt3fbk4qrod5pzo',
    nocoContactTable: 'm96hjgxebcqbm6o',
    nocoBackupTable: 'mabigixegv8pez9',
    nocoOrderTable: 'm0ye7gy9ztwle4t',
    flowUrl: 'https://flow.acrow.de',
  },
  authTokens: {
    flowToken: 'VohHEMe42R6d5',
    nocoDBToken: 'QHgvcL8I-oC-ZalJgO7c_acIwRcj_gQLY9bjY2ko',
  },
  ...appVersion,
};
